var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        width: "800px",
        visible: _vm.visible,
        modal: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm.title === "请选择可发起本审批的部门"
        ? _c(
            "el-form-item",
            { attrs: { labelCol: { span: 3 }, label: "部门权限" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.scope,
                    callback: function ($$v) {
                      _vm.scope = $$v
                    },
                    expression: "scope",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "本级" } }, [
                    _vm._v("本级"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "本级及以下" } }, [
                    _vm._v("本级及以下"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "picker" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "candidate",
          },
          [
            _c(
              "div",
              [
                _c("el-input", {
                  staticStyle: { width: "90%" },
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder:
                      _vm.type === "org"
                        ? "输入搜索"
                        : _vm.type === "dept"
                        ? "搜索部门"
                        : _vm.type === "post"
                        ? "搜索岗位"
                        : "搜索人员",
                    "prefix-icon": "el-icon-search",
                  },
                  on: { input: _vm.searchUser, clear: _vm.clearOptions },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      float: "right",
                      "margin-top": "5px",
                      color: "#38adff",
                    },
                    on: { click: _vm.clearOptions },
                  },
                  [_vm._v("重置")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showUsers,
                        expression: "!showUsers",
                      },
                    ],
                  },
                  [
                    _c(
                      "ellipsis",
                      {
                        staticStyle: { color: "#8c8c8c", padding: "5px 0 0" },
                        attrs: {
                          "hover-tip": "",
                          row: 1,
                          length: 15,
                          tooltip: "",
                          content: _vm.deptStackStr,
                        },
                      },
                      [_c("i", { staticClass: "el-icon-office-building" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "5px" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { disabled: !_vm.multiple },
                            on: { change: _vm.handleCheckAllChange },
                            model: {
                              value: _vm.checkAll,
                              callback: function ($$v) {
                                _vm.checkAll = $$v
                              },
                              expression: "checkAll",
                            },
                          },
                          [_vm._v("全选")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.deptStack.length > 0,
                                expression: "deptStack.length > 0",
                              },
                            ],
                            staticClass: "top-dept",
                            on: { click: _vm.beforeNode },
                          },
                          [_vm._v("上一级")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "org-items",
                style: _vm.type === "role" ? "height: 350px" : "",
              },
              [
                _c("el-empty", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.orgs.length === 0,
                      expression: "orgs.length === 0",
                    },
                  ],
                  attrs: { "image-size": 100, description: "似乎没有数据" },
                }),
                _vm._v(" "),
                _vm._l(_vm.orgs, function (org, index) {
                  return _c(
                    "div",
                    { key: index, class: _vm.orgItemClass(org) },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { max: 2, disabled: _vm.disableDept(org) },
                            on: {
                              change: function ($event) {
                                return _vm.selectChange(org)
                              },
                            },
                            model: {
                              value: org.selected,
                              callback: function ($$v) {
                                _vm.$set(org, "selected", $$v)
                              },
                              expression: "org.selected",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      org.type === "dept"
                        ? _c("div", { staticStyle: { width: "80%" } }, [
                            _c("i", { staticClass: "el-icon-folder-opened" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(org.name)),
                            ]),
                            _vm._v(" "),
                            _vm.type === "dept"
                              ? _c("span", {}, [
                                  !org.leaf
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "top-dept",
                                          class:
                                            "next-dept" +
                                            (org.selected ? "" : ""),
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.nextNode(org)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-map-site",
                                          }),
                                          _vm._v(
                                            "下级\n                            "
                                          ),
                                        ]
                                      )
                                    : _c("span", {
                                        staticClass: "top-dept",
                                        class:
                                          "next-dept" +
                                          (org.selected ? "-disable" : ""),
                                      }),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "top-dept",
                                    class:
                                      "next-dept" + (org.selected ? "" : ""),
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.nextNode(org)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont icon-map-site",
                                    }),
                                    _vm._v("下级\n                        "),
                                  ]
                                ),
                          ])
                        : org.type === "user" || org.type === "post"
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                width: "80%",
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(org.name)),
                              ]),
                            ]
                          )
                        : _c(
                            "div",
                            { staticStyle: { display: "inline-block" } },
                            [
                              _c("i", { staticClass: "iconfont icon-bumen" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(org.name)),
                              ]),
                            ]
                          ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "selected" }, [
          _c("div", { staticClass: "count" }, [
            _c("span", [_vm._v("已选 " + _vm._s(_vm.select.length) + " 项")]),
            _vm._v(" "),
            _c("span", { on: { click: _vm.clearSelected } }, [_vm._v("清空")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "org-items", staticStyle: { height: "350px" } },
            [
              _c("el-empty", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.select.length === 0,
                    expression: "select.length === 0",
                  },
                ],
                attrs: {
                  "image-size": 100,
                  description: "请点击左侧列表选择数据",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.changeDeptName(_vm.select), function (org, index) {
                return _c("div", { key: index, class: _vm.orgItemClass(org) }, [
                  org.type === "dept"
                    ? _c("div", [
                        _c("i", { staticClass: "el-icon-folder-opened" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "name",
                            staticStyle: { position: "static" },
                          },
                          [_vm._v(_vm._s(org.name))]
                        ),
                      ])
                    : org.type === "user" || org.type === "post"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(org.name)),
                          ]),
                        ]
                      )
                    : _c("div", [
                        _c("i", { staticClass: "iconfont icon-bumen" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(org.name)),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-close",
                    on: {
                      click: function ($event) {
                        return _vm.noSelected(index)
                      },
                    },
                  }),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.selectOk } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }